import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import { filterTypesKey, I_Category, I_Type, I_Group, I_Tag } from '@Redux/search/interfaces';
import { RootState } from '@Redux/search/store';
import TripTypeList from './TripTypeList';
import Type from './Type';
import Category from './Category';
import styles from '../styles.module.scss';
import { setFilterItems, setTags, setTagFiltersShow } from '@Redux/search/actions';

/*
    Category: {
        CategoryName: string;
        CategoryCdoe: string;
        CategorySort: number;
        TypeList: Type[]
    }

    Type: {
        TypeName: string;
        TypeCode: string;
        TypeSort: number;
        TripTypeName: string;
        TripTypeCode: string;
        TripTypeSort: number;
        GroupList: Group[]
    }

    Group: {
        GroupName: string;
        GropuNo: string;
        GroupSort: string;
        TagList: Tag[]
    }

    Tag: {
        TagName: string;
        TagNo: string;
        TagSort: number;
        IsDelete: boolean;
    }
*/

let gateTypeCodes = true;
const FiltersBlock: React.FC<any> = () => {
    const { DepthInfo, FilterItems } = useSelector((state: RootState) => state.search);
    const moduleName = 'filtersBlock';
    const url = new URL(location.href);
    const dispatch = useDispatch();
    const setFilterItemsArr: any = [];
    const transportArr: any = [];
    // 不區分大小寫抓取 TripTypes
    const TypeCodes: any =
        url.href.toLowerCase().indexOf('triptypes') !== -1
            ? url.href.toLowerCase().split('triptypes=')[1].split('&')[0] ||
              url.href.toLowerCase().split('triptypes=')[1]
            : undefined;
    
    // 遊玩交通子標籤 (03)
    const tripCategory = DepthInfo.CategoryList.find(
        (Category: I_Category) => Category.CategoryCode === '03'
    );
    // 產品規格 (01)、行銷活動 (02) 標籤
    const nonTripCategories = DepthInfo.CategoryList.filter(
        (Category: I_Category) => Category.CategoryCode !== '03'
    );

    const setClientDefaultTypeCode = () => {
        if (TypeCodes.indexOf(',') === -1) {
            if (transportArr.indexOf(TypeCodes) === -1) {
                transportArr.push(TypeCodes);
            }
            //當有多個TypeCode
        } else {
            TypeCodes.split(',').forEach((code: string) => {
                if (transportArr.indexOf(code) === -1) {
                    transportArr.push(code);
                }
            });
        }
        gateTypeCodes = false;
    };

    //針對Url的TypeCode做處理
    useEffect(() => {
        if (TypeCodes && gateTypeCodes) {
            // 可讓遊玩交通單獨亮起來
            setClientDefaultTypeCode();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [TypeCodes]);

    useEffect(() => {
        dispatch(setTagFiltersShow(transportArr));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return DepthInfo ? (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            {DepthInfo?.TripTypeList.length > 0 && (
                <>
                    {/* 主要交通標籤 */}
                    <TripTypeList tripTypes={DepthInfo.TripTypeList} title="遊玩交通" />
                    {/* 交通標間下子標籤 */}
                    {tripCategory && (
                        <ul
                            className={cN(styles.ListDetails, styles.tripCategory)}
                            key={tripCategory.CategoryCode}
                            data-cy="tripCategory"
                        >
                            {tripCategory.TypeList.map(
                                ({ TypeCode, TripTypeCode, TripTypeName, GroupList }: I_Type) => (
                                    <Type
                                        key={TypeCode}
                                        TripTypeCode={TripTypeCode}
                                        TripTypeName={TripTypeName}
                                        GroupList={GroupList}
                                        CategoryCode={tripCategory.CategoryCode}
                                    />
                                )
                            )}
                        </ul>
                    )}
                </>
            )}
            {nonTripCategories.map(({ CategoryCode, TypeList }: I_Category) => (
                <Category key={CategoryCode} CategoryCode={CategoryCode} TypeList={TypeList} />
            ))}
        </div>
    ) : null;
};

export default FiltersBlock;
